import {OKTA_EXTERNAL_CONFIG, OKTA_INTERNAL_CONFIG} from './utils/constant';

const externalConfig = OKTA_EXTERNAL_CONFIG;

const internalConfig = OKTA_INTERNAL_CONFIG;
  
console.log('HERE IS YOUR NEW UPDATED FILEF=====================>', {'externalConfig' : OKTA_EXTERNAL_CONFIG, 'internalConfig': OKTA_INTERNAL_CONFIG, 'ENV': process.env});
 



// const externalConfig = {
//   issuer: "https://pepsico.oktapreview.com/oauth2/default",
//   clientId: "0oa2813m80qmCuaCX0h8",
//   redirectUri: `http://localhost:5000/login/callback`,
//   scopes: ["openid", "profile", "email"],
//   pkce: true,
// };

// const internalConfig = {
//   issuer: "https://secure.ite.pepsico.com/oauth2/default",
//   clientId: "0oa28eji7otDmrHQs0h8",
//   redirectUri: `http://localhost:5000/login/callback`,
//   scopes: ["openid", "profile", "email"],
//   pkce: true,
// };

export { externalConfig, internalConfig };

  //  client_id: '"0oa28eji7otDmrHQs0h8',
  // client_secret: '6W7XvLCrs4ByKn7Ucwh8ygeeXRhdGFdVOTp75eOc',
  // grant_type: 'authorization_code',
  // redirect_uri: ' https://agro-hub-ui.dps.gw01.aks01.eus.nonprod.azure.intra.pepsico.com/',
  // code: 'QnowT-aeawtOJKp-MtkH&'
// console.log('Fixing the Env issue', {'externalConfig' : externalConfig, 'internalConfig': internalConfig, 'ENV': process.env });

